import { Component } from '../lib/ComponentBase';
import { simpleComponent } from '../lib/ComponentHelpers';
import type { TagComponent } from '../types/Components';

/**
 * A tag component that marks an entity as dead.
 * Dead entities should not be able to act.
 */
class Dead extends Component implements TagComponent {}

export default simpleComponent(Dead);
